import 'src/assets/js/shared/auth_component/sign_in.js';
import 'src/assets/js/shared/auth_component/reviews.js';
import 'src/assets/js/shared/auth_component/deals_subscription_in_panel.js';
import 'src/assets/js/shared/auth_component/deals_subscription_in_popup.js';
import 'src/assets/js/shared/auth_component/demands.js';
